import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useDisclaimer = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const addDisclaimer = async (newData, applyData) => {
    const responseData = await sendRequest({
      url: '/api/v1/disclaimer',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: { ...newData },
    });

    applyData(responseData);
  };

  const getUnseenDisclaimers = () => {
    return new Promise(async (resolve, reject) => {
      const responseData = await sendRequest({
        url: '/api/v1/disclaimer/unseen',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      });

      resolve(responseData);
    });
  };

  // Waivers of a single booking, including the ones signed in advance.
  const getDisclaimersForBooking = async bookingId => {
    return await sendRequest({
      url: `/api/v1/disclaimer/booking/${bookingId}`,
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
  };

  // Bookings of one day with their waiver status. date is optional (YYYY-MM-DD).
  const getAdvanceDisclaimers = async date => {
    return await sendRequest({
      url: '/api/v1/disclaimer/advance',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
      params: { date },
    });
  };

  // Single waiver including the signature image.
  const getDisclaimer = async disclaimerId => {
    return await sendRequest({
      url: `/api/v1/disclaimer/${disclaimerId}`,
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
  };

  return {
    isLoading,
    error,
    addDisclaimer,
    getUnseenDisclaimers,
    getDisclaimersForBooking,
    getAdvanceDisclaimers,
    getDisclaimer,
  };
};

export default useDisclaimer;
